import { Flex, type FlexboxProps, Grid } from "@chakra-ui/react"
import type { ReactNode } from "react"

import ConfidentialLines from "../ConfidentialLines"
import FormLabelRequired from "../FormLabel/FormLabelRequired"
import FieldLabel from "./FieldLabel"
import type { SharedFieldProps } from "./types"

type Props = React.PropsWithChildren<
  {
    label: ReactNode | string
    labelColor?: string
    labelTextAlign?: "left" | "center" | "right"
    required?: boolean
    gap?: string
    gridTemplateColumns?: string
    width?: string
  } & SharedFieldProps &
    FlexboxProps
>

export default function SingleField({
  label,
  labelColor,
  labelTextAlign,
  required,
  children,
  isConfidential,
  alignItems,
  justifyContent,
  gridTemplateColumns,
  gap,
  width,
  flexDir,
}: Props) {
  return (
    <Grid
      // Label above the value on a phone, beside it from md.
      columnGap={gap ?? "6"}
      gridTemplateColumns={
        gridTemplateColumns ?? { base: "minmax(0, 1fr)", md: "160px minmax(0, 1fr)" }
      }
      alignItems={alignItems ?? "start"}
      justifyContent={justifyContent ?? "start"}
      width={width ?? "100%"}
    >
      <FieldLabel
        pt={2}
        pb={{ base: 0, md: 2 }}
        disabled={isConfidential}
        color={labelColor}
        textAlign={labelTextAlign}
      >
        {label}
        {required && <FormLabelRequired />}
      </FieldLabel>
      {isConfidential ? (
        <ConfidentialLines py={2} />
      ) : (
        <Flex py={2} alignSelf="start" flexShrink={0} flexGrow={1} flexDir={flexDir ?? "row"}>
          {children}
        </Flex>
      )}
    </Grid>
  )
}
